import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useEffect } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import AccordionAccountholderForm from './form';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';

interface AccountholderProps {
  disabled?: boolean;
}

const AccountholderComponent = ({ disabled }: AccountholderProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificationFormVM>();

  useEffect(() => {
    if (formContext?.values?.flagInternal && !disabled && !open) {
      setOpen(true);
    }
  }, [formContext?.values?.flagInternal, disabled, open]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-accountholder-content"
        id="panel-certificate-accountholder-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Intestatario</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionAccountholderForm />
      </AccordionDetails>
    </Accordion>
  );
};

AccountholderComponent.displayName = 'Accordion accountholder component';

const Accountholder = memo(AccountholderComponent);

export default Accountholder;
